export const websites = [
  'https://qa-www.tvb.com',
  'https://www.tvb.com',
  'https://homepage-4e5c5tu4dq-df.a.run.app'
]

export const adsConfig = {
  HomePage: { position: 6, unit: '/home' },
  category: { position: 7, unit: '/content' },
  subCategory: { position: 8, unit: '/content' },
  detail: { position: 9, unit: '/content' },
  search: { position: 10, unit: '/content/search' },
  // 视频相关配置
  videoDetail: { position: 14, unit: '/content' },
  videoPlayer: { position: 11, unit: '/video' },
  videoCategory: { position: 12, unit: '/video' },
  videoSubCategory: { position: 13, unit: '/video' }
}

export const categoryType = {
  article: 1,
  video: 2
}
